<template>
  <div class="buy-feature">
    <Alert type="warning"> {{ $t('ti-shi') }}{{ featureDesc }} </Alert>
    <div v-if="canUpgrade" class="tip">
      <div class="left">
        <div class="tip-left-title">{{ $t('yan-bi-bu-gou-yong') }}</div>
        <div>
          {{
            $t('ni-huan-ke-yi-tong-guo-tao-can-sheng-ji-zeng-gou-yan-bi-zhe-yang-geng-hua-suan-o')
          }}
        </div>
      </div>
      <Button class="right upgrade-btn" variant="warning" @click="showUpgradeEquityModal()">
        {{ $t('tao-can-sheng-ji') }}
        <IconArrow class="upgrade-icon"></IconArrow>
      </Button>
    </div>
    <div class="buy-feature__block">
      <h4 class="buy-feature__block-title">{{ $t('yan-bi-tao-can') }}</h4>
      <TeamBuy
        v-if="user?.rights_type === IRightsType.TEAM_LIGHT"
        :picked="pickedPackage"
        :packages="packages"
        :rightsName="rightsName"
        @change="handlePick"
      />
      <PersonalBuy v-else :packages="packages" :picked="pickedPackage" @change="handlePick" />
    </div>
  </div>
</template>

<script setup lang="ts" name="BuyFeature">
import {
  getRightsCreditCoinsPackage,
  type ICreditCoinsPackage,
} from '@rendora/common/entities/rights';
import { getI18nService } from '@rendora/common/services/i18n';
import { useUserStore } from '@rendora/common/store';
import type { RIGHTS_FEATURE } from '@rendora/common/types/enums';
import { IRightsType } from '@rendora/common/types/enums';
import IconArrow from '@rendora/design/assets/arrow.svg?component';
import Alert from '@rendora/design/components/alert/Alert.vue';
import { Button } from '@rendora/design/components/button/index';
import { computed, onMounted, ref } from 'vue';
import { showUpgradeEquityModal } from '../upgrade-equity';
import PersonalBuy from './PersonalBuy.vue';
import TeamBuy from './TeamBuy.vue';

const i18nService = getI18nService();
const $t = i18nService.t;

withDefaults(
  defineProps<{
    pending: boolean;
    packageInfo?: ICreditCoinsPackage;
    rightsName: string;
    featureType: RIGHTS_FEATURE;
    unitPrice: number;
    days?: number;
  }>(),
  {
    days: 0,
  },
);

const { user, canUpgrade } = useUserStore();
const emits = defineEmits(['update:packageInfo', 'update:pending']);
const pickedPackage = ref<ICreditCoinsPackage>();

const handlePick = (item: ICreditCoinsPackage) => {
  pickedPackage.value = item;
  emits('update:packageInfo', item);
};

const coinsPackages = ref<ICreditCoinsPackage[]>([]);

const fetchCoinsPackages = async () => {
  if (!user || !user.rights_type) return;
  const res = await getRightsCreditCoinsPackage({
    many: '1',
    rights_type: user.rights_type,
  });
  coinsPackages.value = res.data!;
  handlePick(coinsPackages.value[0]);
};

onMounted(async () => {
  await fetchCoinsPackages();
});

const packages = computed(() => coinsPackages.value || []);

const featureDesc = computed(() =>
  [
    $t(
      'jia-gou-de-yan-bi-gou-mai-cheng-gong-hou-li-ji-sheng-xiao-yi-jing-sheng-xiao-bu-ke-tui-kuan',
    ),
    $t('tao-can-you-xiao-qi-nei-ke-yong-chang-qi-bao-liu'),
  ].join('、'),
);
</script>

<style lang="scss" scoped>
.tip {
  display: flex;
  justify-content: space-between;
  padding-left: 10px;
  margin-top: 35px;
  .tip-left-title {
    color: var(--x-warning-7);
    font-size: 14px;
    font-weight: var(--x-weight-medium);
    line-height: 20px;
  }
  .upgrade-btn {
    width: 130px;
  }
}

.buy-feature {
  padding: 24px;
  width: v-bind('`${Math.min(3, packages.length) * 230}px`');

  .buy-feature__block-title {
    color: var(--x-text-1);
    font-weight: var(--x-weight-medium);
    line-height: 20px;
    margin-bottom: 15px;
  }

  &__desc {
    padding-top: 16px;
    color: var(--x-text-1);
    font-size: 14px;
    line-height: 24px;
    opacity: 0.6;
  }
  &__block {
    margin-top: 30px;
    // column-gap: 20px;
    &--label {
      width: 48px;
      opacity: 0.6;
    }
  }
}

.upgrade-icon {
  margin-left: 3px;
  width: 20px;
}
</style>
